import React from 'react';
import PropTypes from 'prop-types';

import { FormattedNumber } from 'react-intl';

const FormattedCurrency = ({
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  value,
  className,
}) => (
  <span className={className}>
    <FormattedNumber
      value={value}
      format="currency"
      minimumFractionDigits={minimumFractionDigits}
      maximumFractionDigits={maximumFractionDigits}
    />
  </span>
);

FormattedCurrency.propTypes = {
  value: PropTypes.number.isRequired,
  minimumFractionDigits: PropTypes.number,
  maximumFractionDigits: PropTypes.number,
  className: PropTypes.string,
};
FormattedCurrency.defaultProps = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  className: '',
};

export default FormattedCurrency;
